import React from 'react'
import { FetchStatus } from 'state/types'
import { formatNumber } from 'utils/formatters'
import { IconWrapper } from 'components/styles'
import LoadableValue from 'components/LoadableValue'
import { StyledBlock, StyledLabel } from './styles'

export interface CardItemProps {
  icon: React.ReactElement
  background: string
  value: number
  label: string
  title: string
  fetchStatus: FetchStatus
}

const CardItem: React.FC<CardItemProps> = ({ icon, background, value, label, title, fetchStatus }) => (
  <div className="flex flex-col gap-8">
    <StyledLabel>{label}</StyledLabel>
    <StyledBlock className={background}>
      <IconWrapper bgColor="white" size="32px">
        {icon}
      </IconWrapper>
      <div>
        <div className="text-12 text-white/50">{title}</div>
        <LoadableValue loading={fetchStatus !== FetchStatus.FETCHED} fontSize="18px" bold>
          {formatNumber(value)} NMX
        </LoadableValue>
      </div>
    </StyledBlock>
  </div>
)

export default CardItem
